// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2_Mzi","unreadBadge":"styles_unreadBadge__197q-","modalContent":"styles_modalContent__28-qs","modal":"styles_modal__2s8Bb"};